import React, { useEffect } from "react";
import { useI18n } from "@/lib/i18n";
import PageTitle from "@/components/PageTitle";

const TermsPage = () => {
  const { t } = useI18n();
  useEffect(() => {
    document.title = t("pageTitles.terms");
  }, [t]);

  const SECTIONS = ["object", "use", "ip", "liability", "modifications", "law"];

  return (
    <main data-testid="terms-page" className="bg-white">
      <PageTitle
        title={t("terms.title")}
        subtitle={t("pageHeader.termsSubtitle")}
        breadcrumbKey="terms"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="text-sm text-slate-500">{t("terms.updated")}</p>
        <p className="mt-6 text-base text-slate-700 leading-relaxed">
          {t("terms.intro")}
        </p>

        <div className="mt-10 space-y-10">
          {SECTIONS.map((key) => (
            <section key={key} data-testid={`terms-section-${key}`}>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                {t(`terms.sections.${key}.title`)}
              </h2>
              <p className="mt-3 text-base text-slate-700 leading-relaxed">
                {t(`terms.sections.${key}.body`)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};

export default TermsPage;
